export enum NursingArea {
  ElderlyCare = 'elderly_care',
  Nursing = 'nursing',
  MedicalStaff = 'medical_staff',
  Docia = 'docia',
  Other = 'other',
}
